'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./index.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import JSONUtil from './jsonUtils';


var startX = 0;
var maxWidth = void 0,
    minWidth = void 0;
var shouldMove = false;
var throttle = function throttle(fn, delay, mustRunDelay) {
  var timer = null;
  var tStart;

  return function () {
    var context = this;
    var args = arguments;
    var tCurr = +new Date();

    clearTimeout(timer);
    if (!tStart) {
      tStart = tCurr;
    }
    if (tCurr - tStart >= mustRunDelay) {
      fn.apply(context, args);
      tStart = tCurr;
    } else {
      timer = setTimeout(function () {
        fn.apply(context, args);
      }, delay);
    }
  };
};

var Dialog = function (_Component) {
  _inherits(Dialog, _Component);

  function Dialog(props) {
    _classCallCheck(this, Dialog);

    var _this = _possibleConstructorReturn(this, (Dialog.__proto__ || Object.getPrototypeOf(Dialog)).call(this, props));

    _this.state = {
      tab: 'headers',
      dialogWidth: 900,
      viewParsed: true
    };

    document.onmousemove = throttle(_this.onMousemove.bind(_this), 50, 100);
    document.onmouseup = _this.onMouseup.bind(_this);
    return _this;
  }

  _createClass(Dialog, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.requestDetail && this.state.tab == 'response') {
        if (nextProps.requestDetail.id !== this.props.requestDetail.id) {
          var cache = getCacheBody(nextProps.requestDetail.id);
          if (cache) {
            return this.setState({
              responseBody: cache,
              // tab: 'headers',
              viewParsed: true
            });
          }
          if (nextProps.requestDetail.originLength <= 1 * 1024 * 1024) {
            fetch('/fetchresponse?reqId=' + nextProps.requestDetail.id).then(function (data) {
              return data.text();
            }).then(function (body) {
              cacheBody(nextProps.requestDetail.id, body);
              _this2.setState({
                responseBody: body,
                // tab: 'headers',
                viewParsed: true
              });
            });
          } else {
            this.setState({
              responseBody: '',
              // tab: 'headers',
              viewParsed: true
            });
          }
        }
      } else {
        this.setState({
          // tab: 'headers',
          viewParsed: true
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      // var block = document.getElementById('js-code');
      // var text = block && block.textContent || '';
      // block && text.length < 20 * 1024 && hljs.highlightBlock(block);
    }
  }, {
    key: 'onMousedown',
    value: function onMousedown(eve) {
      shouldMove = true;
      maxWidth = 1200;
      minWidth = 100;
      startX = eve.clientX;
      eve.preventDefault();
    }
  }, {
    key: 'onMousemove',
    value: function onMousemove(eve) {
      if (!shouldMove) {
        return;
      }
      var clientX = eve.clientX;

      var delta = startX - clientX;
      startX = startX - delta;
      var width = parseInt(document.querySelector('.dialog').style.width);
      width += delta;
      width = width < minWidth ? minWidth : width > maxWidth ? maxWidth : width;
      document.querySelector('.dialog').style.width = width + 'px';
    }
  }, {
    key: 'onMouseup',
    value: function onMouseup() {
      shouldMove = false;
    }
  }, {
    key: 'changeViewJson',
    value: function changeViewJson() {
      var viewParsed = this.state.viewParsed;
      this.setState({ viewParsed: !viewParsed });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          showRequestDetail = _props.showRequestDetail,
          requestDetail = _props.requestDetail,
          onClose = _props.onClose;

      var tab = this.state.tab;
      var responseBody = this.state.responseBody;

      if (!showRequestDetail) {
        return null;
      }
      var t = requestDetail;

      var content = function content() {
        if (tab === 'headers') {
          return _react2.default.createElement(
            'section',
            { className: 'body' },
            _react2.default.createElement(
              'h3',
              { className: 'header' },
              'General'
            ),
            _react2.default.createElement(
              'ul',
              { className: 'list' },
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'Request URL:'
                ),
                '  ',
                t.url.href
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'Proxy URL:'
                ),
                '  ',
                t.newUrl
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'Request Method:'
                ),
                ' ',
                t.method
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'Status Code:'
                ),
                ' ',
                t.statusCode
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'Remote Address:'
                ),
                ' ',
                t.hostname
              )
            ),
            _react2.default.createElement(
              'h3',
              { className: 'header' },
              'Response Headers'
            ),
            _react2.default.createElement(
              'ul',
              { className: 'list' },
              parseData(t.resHeaders)
            ),
            _react2.default.createElement(
              'h3',
              { className: 'header' },
              'Request Headers'
            ),
            _react2.default.createElement(
              'ul',
              { className: 'list' },
              parseData(t.headers)
            ),
            _this3.renderParams(t)
          );
        } else if (tab === 'response') {
          // 获取content-type
          var resHeaders = t.resHeaders,
              fileType = t.fileType;


          var targetURL = t.protocol + '//' + t.hostname + (t.port ? ':' + t.port : '') + t.path;

          if (/^(html|css|javascript|json|text)$/.test(fileType)) {
            if (t.originLength > 1 * 1024 * 1024) {
              return _react2.default.createElement(
                'div',
                { style: { padding: '10px' } },
                '\u6587\u4EF6\u5185\u5BB9\u592A\u957F\uFF0C',
                _react2.default.createElement(
                  'a',
                  { href: targetURL, target: '_blank' },
                  '\u70B9\u51FB\u6B64\u5904'
                ),
                '\u5728\u65B0\u7A97\u53E3\u4E2D\u6253\u5F00\u3002'
              );
            } else {
              var data = responseBody;

              if (fileType === 'json') {
                try {
                  data = JSON.stringify(JSON.parse(t.socketData), null, 2);
                } catch (err) {
                  // ...
                  data = responseBody;
                }
              }
              return _react2.default.createElement(
                'pre',
                { className: 'code', id: 'js-code' },
                _react2.default.createElement(
                  'code',
                  { className: fileType },
                  data
                )
              );
            }
          } else if (/^(png|jpg|jpeg|gif|ico|svg)$/.test(fileType)) {
            return _react2.default.createElement(
              'div',
              { className: 'content' },
              _react2.default.createElement('img', { src: targetURL })
            );
          } else {
            return _react2.default.createElement(
              'div',
              { style: { padding: '10px' } },
              '\u6682\u65F6\u4E0D\u652F\u6301\u6B64\u7C7B\u578B\u6587\u4EF6\u9884\u89C8\uFF0C',
              _react2.default.createElement(
                'a',
                { href: targetURL, target: '_blank' },
                '\u70B9\u51FB\u6B64\u5904'
              ),
              '\u5728\u65B0\u7A97\u53E3\u4E2D\u6253\u5F00\u3002'
            );
          }
        }
      };

      return _react2.default.createElement(
        'div',
        { className: 'dialog', style: { width: this.state.dialogWidth + 'px' } },
        _react2.default.createElement('div', { id: 'spliter',
          onMouseDown: this.onMousedown.bind(this)
        }),
        _react2.default.createElement(
          'header',
          null,
          _react2.default.createElement(
            'div',
            { className: 'close', onClick: this.close.bind(this) },
            '\xD7'
          ),
          _react2.default.createElement(
            'div',
            { className: tab === 'headers' ? 'tab active' : 'tab',
              onClick: this.switchTab.bind(this, 'headers', t.id, t.originLength) },
            'Headers'
          ),
          _react2.default.createElement(
            'div',
            { className: tab === 'response' ? 'tab active' : 'tab',
              onClick: this.switchTab.bind(this, 'response', t.id, t.originLength) },
            'Response'
          )
        ),
        content()
      );
    }
  }, {
    key: 'renderParams',
    value: function renderParams(t) {
      var bodyType = getBodyType(t);
      var method = t.method.toLocaleLowerCase();
      var bodyOrqs = method === 'get' ? t.querystring : t.body;
      var bodyData = getBody(t);
      var body = '';
      var viewParsed = this.state.viewParsed;


      if (!bodyType || !bodyData) {
        return null;
      }

      if (bodyType === 'Request Payload' || !viewParsed) {
        body = _react2.default.createElement(
          'pre',
          null,
          _react2.default.createElement(
            'code',
            null,
            viewParsed ? bodyData : bodyOrqs
          )
        );
      } else {
        body = _react2.default.createElement(
          'ul',
          { className: 'list' },
          bodyData
        );
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h3',
          { className: 'header' },
          bodyType,
          _react2.default.createElement(
            'span',
            {
              style: { marginLeft: '20px', fontSize: '12px', color: '#838383' },
              onClick: this.changeViewJson.bind(this)
            },
            viewParsed ? 'view source' : 'view parsed'
          )
        ),
        body
      );
    }
  }, {
    key: 'close',
    value: function close(eve) {
      var onClose = this.props.onClose;


      onClose && onClose();
    }
  }, {
    key: 'switchTab',
    value: function switchTab(tab, id, len) {
      var _this4 = this;

      var cache = getCacheBody(id);
      if (cache) {
        return this.setState({
          responseBody: cache,
          tab: tab
        });
      }

      if (tab === 'response') {
        if (len <= 1 * 1024 * 1024) {
          fetch('/fetchresponse?reqId=' + id).then(function (data) {
            return data.text();
          }).then(function (body) {
            cacheBody(id, body);
            _this4.setState({
              responseBody: body,
              tab: tab
            });
          });
        } else {
          this.setState({
            responseBody: '',
            tab: tab
          });
        }
      } else {
        this.setState({ tab: tab });
      }
    }
  }, {
    key: 'showRequestDetail',
    value: function showRequestDetail(item) {
      this.setState({
        showRequestDetail: true,
        requestDetail: item
      });
    }
  }]);

  return Dialog;
}(_react.Component);

exports.default = Dialog;


function parseData(data) {
  var result = [];

  for (var key in data) {
    result.push(_react2.default.createElement(
      'li',
      { key: key },
      _react2.default.createElement(
        'strong',
        null,
        key
      ),
      ': ',
      data[key]
    ));
  }

  return result;
}

function getQueryObjFromURL(params) {
  if (!params) {
    return null;
  }

  var res = {};
  var fields = params.split('&');

  fields.forEach(function (field) {
    var kv = field.split('=');
    var key = kv[0];
    var value = kv.slice(1).join('=');

    if (key) {
      if (key in res) {
        res[key] = [].concat(res[key], value);
      } else {
        res[key] = decodeURIComponent(value);
      }
    }
  });

  return res;
}

function getBody(t) {
  var body = t.body;
  var querystring = t.querystring;
  var data = null;
  var method = t.method.toLocaleLowerCase();
  var contentType = t.headers['content-type'] || '';
  var isJSON = contentType.indexOf('json') !== -1;

  if (method === 'get') {
    data = getQueryObjFromURL(querystring);
  } else if (method === 'post') {
    if (isJSON) {
      try {
        data = JSON.parse(body);
      } catch (e) {
        isJSON = false;
        data = getQueryObjFromURL(body);
      }
    } else {
      data = getQueryObjFromURL(body);
    }
  }

  return isJSON ? JSON.stringify(data, null, 2) : parseData(data);
}

function getBodyType(ctx) {
  var method = ctx.method.toLocaleLowerCase();
  if (method === 'get') {
    return 'Query String Paramenters';
  }

  if (method === 'post') {
    var isJson = false;
    try {
      JSON.parse(ctx.body);
      isJson = true;
    } catch (e) {}

    return isJson ? 'Request Payload' : 'Form data';
  }

  return null;
}

function cacheBody(id, val) {
  sessionStorage.setItem(id, val);
}

function getCacheBody(id) {
  return sessionStorage.getItem(id);
}


//////////////////
// WEBPACK FOOTER
// ./src/page/dialog.js
// module id = 352
// module chunks = 0